<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Fleet Managers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Fleet Managers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <!-- users view media object start -->
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <div class="media mb-2">
                            <a class="mr-1" href="#">
                                <img :src="fleetManagerData.profile_photo_url ?? 'https://ui-avatars.com/api/?name=' + fleetManagerData.first_name + '+' + fleetManagerData.last_name"
                                     alt="users view avatar" class="users-avatar-shadow rounded-circle" height="64"
                                     width="64">
                            </a>
                            <div class="media-body pt-25">
                                <h4 class="media-heading">
                                    <span class="users-view-name">
                                        {{ fleetManagerData.first_name + " " + fleetManagerData.last_name }}
                                    </span>
                                </h4>
                                <span>ID:</span>
                                <span class="users-view-id">{{ fleetManagerData.id }}</span>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12 col-sm-5 px-0 d-flex justify-content-end align-items-center px-1 mb-2">-->
<!--                        <a href="#" class="btn btn-sm mr-25 border"><i-->
<!--                            class="feather icon-message-square font-small-3"></i></a>-->
<!--                        <a href="#" class="btn btn-sm mr-25 border">Profile</a>-->
<!--                        <a href="#"-->
<!--                           class="btn btn-sm btn-primary">Edit</a>-->
<!--                    </div>-->
                </div>
                <!-- users view media object ends -->

                <section class="card">
                    <div class="card-body pt-3">
                        <div class="row">
                            <div class="col-md-6 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-wallet stat-icon text-info"></i>
                                    <div class="stat-label">Revenue (%)</div>
                                    <div class="stat-value">{{ fleetManagerData.revenue }}</div>
                                </div>
                            </div>

                            <div class="col-md-6 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-car stat-icon"></i>
                                    <div class="stat-label">No of Vehicles</div>
                                    <div class="stat-value">{{ fleetManagerData.vehicles_count }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- users view card details start -->
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-md-6">
                                <h5 class="mb-1"><i class="feather icon-info"></i> Personal Info</h5>
                                <table class="table table-borderless">
                                    <tbody>
                                    <tr>
                                        <td>Full Name:</td>
                                        <td class="users-view-username">
                                            {{ fleetManagerData.first_name + ' ' + fleetManagerData.last_name}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Email:</td>
                                        <td class="users-view-name">{{ fleetManagerData.email }}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone</td>
                                        <td class="users-view-email">{{ fleetManagerData.phone_number }}</td>
                                    </tr>
                                    <tr>
                                        <td>Registered at:</td>
                                        <td>{{ formatDateTime(fleetManagerData.created_at) }}</td>
                                    </tr>
                                    <!--                                        <tr>-->
                                    <!--                                            <td>Latest Activity:</td>-->
                                    <!--                                            <td class="users-view-latest-activity">30/04/2019</td>-->
                                    <!--                                        </tr>-->
                                    <tr>
                                        <td>Verified:</td>
                                        <td class="users-view-verified">{{ fleetManagerData.email_verified_at ? "Yes" : "No" }}</td>
                                    </tr>
                                    <tr>
                                        <td>Fleet Manager Type:</td>
                                        <td class="users-view-role">Fleet Manager</td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td>
                                            <span :class="'users-view-status badge ' + statusClass(fleetManagerData.email_verified_at)">{{ fleetManagerData.email_verified_at ? "Active" : "Inactive" }}</span>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users view card details ends -->
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Vehicles</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Vehicle Id</th>
                                            <th>Vehicle Type</th>
                                            <th>Vehicle Make</th>
                                            <th>Vehicle Model</th>
                                            <th>License plate</th>
                                            <th>Driver</th>
                                            <th>Current Active Vehicle</th>
                                            <th>Ownership Type</th>
                                            <th>Vehicle Status</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="vehicle in fleetManagerData.vehicles" class="mb-2 p-3">
                                            <th><a :href="route('admin.vehicles.show', vehicle.id)">{{ vehicle.id }}</a></th>
                                            <th>{{ vehicle.type.name }}</th>
                                            <th>{{ vehicle.vehicle_make }}</th>
                                            <th>{{ vehicle.vehicle_model }}</th>
                                            <th>{{ vehicle.license_plate }}</th>
                                            <th>
                                                <a v-if="vehicle.driver" :href="route('admin.drivers.show', vehicle.driver.id)">{{ vehicle.driver.first_name + ' ' + vehicle.driver.last_name }}
                                                </a>
                                                <span v-else>Unassigned</span>
                                            </th>
                                            <th class="text-center">
                                                    <span :class="vehicle.is_active ? 'badge badge-success' : 'badge badge-warning'">
                                                        {{ vehicle.is_active ? 'Yes' : 'No' }}
                                                    </span>
                                            </th>
                                            <th>{{ vehicle.ownership_type }}</th>
                                            <th class="text-center">
                                                    <span :class="'badge-glow badge badge-' + tripStatus(vehicle.status)">
                                                        {{ vehicle.status }}
                                                    </span>
                                            </th>
                                            <th>
                                                <a :href="route('admin.vehicles.show', vehicle.id)">
                                                    <i class="feather icon-eye"></i> View
                                                </a>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Fleet Manager Admin'},
    name: 'FleetManagerShow',
    props: ['fleetManagerData'],
    layout: Layout,
    data() {},
    methods: {
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        tripStatus(value) {
            if (value === 'pending' || value === 'verifying') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit' || value === 'available')
            {
                return "success";
            } else if (value === 'completed' || value === 'active')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
        statusClass(value) {
            return value ? "badge-success" : "badge-warning";
        },
    },
    mounted() {},
}
</script>
